export default __webpack_public_path__ + "static/media/village.311b20a0.webp";